module.exports = __webpack_public_path__ + "static/media/oberflex.d37b3345.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/collections/oberflex.jpg
// module id = 1148
// module chunks = 37